import { render, staticRenderFns } from "./check_programme_dialog.vue?vue&type=template&id=78c58b40"
import script from "./check_programme_dialog.vue?vue&type=script&lang=js"
export * from "./check_programme_dialog.vue?vue&type=script&lang=js"
import style0 from "./check_programme_dialog.vue?vue&type=style&index=0&id=78c58b40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports